/**
 * Favourites
 */

export const favourites = {
    namespaced: true,
    state: () => ({
        items: [],
        addedToast: false,
    }),
    mutations: {
        setFavourites: (state, payload) => {
            state.items = payload.items;
        },

        setAddedToast: (state, payload) => {
            state.addedToast = payload;
        }
    },
    actions: {
        getFavourites: async ({ commit }) => {
            let { data } = await axios.get('/ajax/favourites');

            commit('setFavourites', data);
        },

        addToFavourites: ({ commit, dispatch }, payload) => {
            let params = {
                id: payload
            };

            axios.post('/ajax/favourites/add', params)
                .then(request => {
                    commit('setAddedToast', true);
                    setTimeout(() =>  commit('setAddedToast', false), 3000);
                    dispatch('getFavourites')
                });
        },

        deleteFromFavourites: ({ commit, dispatch }, payload) => {
            axios.delete('/ajax/favourites/delete/' + payload)
                .then(request => dispatch('getFavourites'));
        },
    },
    getters: {
        // items: state => {
        //     return state.items;
        // },
        count: state => state.items.length
    }
}
